import React from "react";
import { Routes, Route } from "react-router-dom";

import CMILayout from "../Layouts/CMI";
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from "./AuthProtected";

const Index = () => (
  <Routes>
    {publicRoutes.map((r, i) => (
      <Route key={i} path={r.path} element={r.component} />
    ))}
    {authProtectedRoutes.map((r, i) => (
      <Route
        key={i}
        path={r.path}
        element={
          <AuthProtected>
            <CMILayout>{r.component}</CMILayout>
          </AuthProtected>
        }
      />
    ))}
  </Routes>
);

export default Index;
